import {
    DefaultButton,
    Dialog, DialogFooter,
    DialogType
} from "@fluentui/react";

import React from "react";
import {useDeleteStorefrontSectionTemplateMutation} from "../../store/endpoints/StorefrontSectionEndpoints";
interface IStorefrontSectionTemplateDeleteModalProps {
    selectedSectionTemplate?: string
    displayModal: boolean;
    onDeleteTemplate?: () => void;
    closer: () => void;
}
const StorefrontSectionTemplateDeleteModal: React.FC<IStorefrontSectionTemplateDeleteModalProps> = props => {
    const [deleteTemplate] = useDeleteStorefrontSectionTemplateMutation();
    return (
        <Dialog
            hidden={!props.displayModal}
            onDismiss={props.closer}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Delete Section Template',
                subText: 'Are you sure you want to delete this section template?',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <DialogFooter>
                <DefaultButton
                    primary
                    text='Delete'
                    onClick={() => {
                        if (props.selectedSectionTemplate) {
                            deleteTemplate({id: props.selectedSectionTemplate}).then(() => {
                                if(props.onDeleteTemplate) props.onDeleteTemplate()
                            });
                        }
                        props.closer()
                    }}
                />
                <DefaultButton
                    text='Cancel'
                    onClick={props.closer}
                />
            </DialogFooter>
        </Dialog>
    );
}
export default StorefrontSectionTemplateDeleteModal;